import { cleanPath, generalDateFormat } from "@enfusion-ui/utils";
import { format } from "date-fns";
import queryString from "query-string";
export default (restServer) => ({
    // GET /internal/api/storage/list/${root}?path=${path}&sortOption=${sortOption}&ascending=${ascending}&query=${query}&fromDate=${fromDate}&toDate=${toDate}&useCreationDate=${useCreationDate}&searchFolders=${searchFolders}
    // type        | name             | value           | required | default |
    // url param   | root             | StorageRoot    | required | null    |
    // url param   | path             | string          | optional | null    |
    // url param   | sortOption       | FileSortOption  | optional | None    |
    // url param   | ascending        | boolean         | optional | true    |
    // url param   | query            | string          | optional | null    |
    // url param   | fromDate         | Date            | optional | null    |
    // url param   | toDate           | Date            | optional | null    |
    // url param   | useCreationDate  | boolean         | optional | false   |
    // url param   | searchFolders    | boolean         | optional | false   |
    LIST_NODES: ({ root, ...params }) => {
        const query = {
            ascending: false,
            ...params,
            toDate: params.toDate
                ? format(params.toDate, generalDateFormat)
                : undefined,
            fromDate: params.fromDate
                ? format(params.fromDate, generalDateFormat)
                : undefined,
            searchFolders: false,
        };
        return restServer(queryString.stringifyUrl({
            url: `/internal/api/storage/list/${root}`,
            query,
        }));
    },
    // POST /internal/api/storage/move/{root}
    // type       | name    | value        | required | default |
    // url param  | root    | StorageRoot  | required | null    |
    // body param | path    | string       | required | null    |
    // body param | newPath | string       | required | null    |
    MOVE_NODE: (root, oldPath, newPath) => restServer(`/internal/api/storage/move/${root}`, {
        body: {
            path: cleanPath(oldPath),
            newPath: cleanPath(newPath, null),
        },
    }),
    // POST /internal/api/storage/copy/{root}
    // type       | name    | value        | required | default |
    // url param  | root    | StorageRoot  | required | null    |
    // body param | path    | string       | required | null    |
    // body param | newPath | string       | required | null    |
    COPY_NODE: (root, oldPath, newPath) => restServer(`/internal/api/storage/copy/${root}`, {
        body: {
            path: cleanPath(oldPath),
            newPath: cleanPath(newPath, null),
        },
    }),
    // POST /internal/api/storage/rename/{root}
    // type       | name | value        | required | default |
    // url param  | root | StorageRoot  | required | null    |
    // body param | path | string       | required | null    |
    // body param | name | string       | required | null    |
    RENAME_NODE: (root, path, newName // file extension required
    ) => restServer(`/internal/api/storage/rename/${root}`, {
        body: {
            path: cleanPath(path),
            name: newName,
        },
    }),
    // POST /internal/api/storage/delete/{root}
    // type       | name | value        | required | default |
    // url param  | root | StorageRoot  | required | null    |
    // body param | path | string       | required | null    |
    DELETE_NODE: (root, path) => restServer(`/internal/api/storage/delete/${root}`, {
        body: {
            path: cleanPath(path),
        },
    }),
    // POST /internal/api/storage/upload/{root}
    // type                 | name      | value        | required | default |
    // url param            | root      | StorageRoot  | required | null    |
    // multipart form param | files     | Files        | required | null    |
    // multipart form param | directory | string       | optional | "/"     |
    UPLOAD_FILES: (root, files, directory) => {
        const body = new FormData();
        for (let i = 0; i < files.length; i += 1) {
            body.append("files", files[i]);
        }
        if (directory.trim() !== "" && directory.trim() !== "/") {
            body.append("directory", directory);
        }
        return restServer(`/internal/api/storage/upload/${root}`, {
            body,
        });
    },
    // POST /internal/api/storage/create-folder/{root}
    // type       | name | value        | required | default |
    // url param  | root | StorageRoot  | required | null    |
    // body param | name | string       | required | null    |
    // body param | path | string       | optional | "/"     |
    CREATE_FOLDER: (root, name, path) => restServer(`/internal/api/storage/create-folder/${root}`, {
        body: {
            name,
            path: cleanPath(path, null),
        },
    }),
});
